<template>
    <main-table-layout
        sub-menu-selector="librarypanel"
    >
        <div slot="buttonsRight"/>
        <content-filter
                slot="filter"
                id="mediaList"
                @filter="filtering"
                store-name="Media"
                :category-filter-items="categoryFilterItems"
                :category-filter-values="categoryFilterValues"
                :team-filtering="true"
                :state-filter-items="['a', 'i', 'h']"
        />
        <view-switcher
                slot="mainContentButtons"
                :id="'mainContent'"
                :table="true"
                :thumbnails="true"
        />
        <pagination
                slot="mainContentButtons"
                :limit="paginationLimit"
                :total="$store.getters.getMediaListOptions(listName, 'pagination_items')"
                id="mediatablepage"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
      <div slot="mainContentButtons">
        <Button
            permission="create"
            type="action-button" slot="mainContentButtons" link="/library/media/add" icon="plus">
          {{ $t('createNewMedia') }}
        </Button>
      </div>
      <Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="rotate-right"
           class="icon-button"
       />
        <table-widget
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                slot="mainContent"
                :id="'mediaDefaultTable'"
                :nav-by-clicking-row="true"
                :deletable="true"
                @deleteRow="deleteRow"
                :show-tags="true"
                :show-organization="true"
                edit-permission="write"
                delete-permission="delete"
                :fields="tableFields"
                :data="$store.getters.getMediasByListName(listName)"
                :title-as-links="true"
                :use-team-permission="true"
                :show-state="true"
                :loading="loading"
                 @sort="sort"
                :initial-sorting="sortObject"
        />
        <thumbnails
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                slot="mainContent"
                :id="'mediaDefaultTable'"
                :deletable="true"
                :nav-by-clicking-row="true"
                edit-permission="write"
                delete-permission="delete"
                :fields="thumbnailFields"
                :data="$store.getters.getMediasByListName(listName)"
                :title-as-links="true"
                :use-team-permission="true"
                :loading="loading"
                :show-state="true"
                 @sort="sort"
        />
</main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import TableWidget from "../components/widgets/TableWidget";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";
    import FileTypeMixin from '@/components/files/FileTypeMixin.js';
    import LoadOverviewMixinJs from "../components/mixins/LoadOverviewMixin.js.vue";

    export default {
        name: "Media",
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        mixins: [
            FileTypeMixin,
            LoadOverviewMixinJs
        ],
        data() {
            return {
                listName: 'MediaList',
                registerMethod: 'registerMediaQueryParams',
                loadMethod: 'loadMedias',
                include: 'tags,teams,versions',
                deleteMethod: 'deleteMedia',
                thumbnailFields: [

                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Organization',
                        id:'organization',
                        type: 'organization',
                        sortable: true
                    },
                    {
                        name: 'Type',
                        id:'type',
                        type: 'string',
                        translate: true,
                        translateFn: (f,i) => `mediaCategory.${i.mediaCategory}`,
                        sortable: true
                    },
                    {
                        name: 'Last Update',
                        id:'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                  {
                    name: 'DisplayName',
                    id:'displayName',
                    type: 'string',
                    sortable: true
                  },
                    {
                      name: 'Teams',
                      id: 'teams',
                      type: 'teams',
                      sortable: false
                    },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                tableFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                  {
                    name: 'DisplayName',
                    id:'displayName',
                    type: 'string',
                    sortable: true
                  },
                    {
                      name: 'Teams',
                      id: 'teams',
                      type: 'teams',
                      sortable: true
                    },
                    {
                        name: 'Type',
                        id:'type',
                        type: 'string',
                        translate: true,
                        translateFn: (f,i) => `mediaCategory.${i.mediaCategory}`,
                        sortable: true
                    },
                    {
                        name: 'Last Update',
                        id:'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
            }
        },
        computed: {
            hasFullMediaFilterAccess() {
                return this.$store.getters.isSFXMember || this.$store.getters.isSuperAdmin;
            },
            categoryFilterItems() {
                const restricted = ['audio', 'image', 'pdf', 'video', 'font'];
                if (this.hasFullMediaFilterAccess) {
                    const allKeys = Object.keys(this.mediaCategories);
                    if (!allKeys.includes('application')) {
                        return ['application', ...allKeys];
                    }
                    return allKeys;
                }
                return restricted;
            },
            categoryFilterValues() {
                return this.categoryFilterItems.map(key => {
                    if (key === 'application') return 0;
                    return this.mediaCategories[key];
                });
            },
        },
        beforeMount() {
          if(this.hasFullMediaFilterAccess) {
            this.$set(this.mediaCategories, 'application', 0);
          }
        },

    }
</script>
